import { render, staticRenderFns } from "./scope73.vue?vue&type=template&id=06a07e20&scoped=true"
import script from "./scope73.vue?vue&type=script&lang=js"
export * from "./scope73.vue?vue&type=script&lang=js"
import style0 from "./scope73.vue?vue&type=style&index=0&id=06a07e20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a07e20",
  null
  
)

export default component.exports